module.exports = __webpack_public_path__ + "static/hand-to-heart-391829ad4b0a82c9f6da1ee45f3a81f7.png";